function Badge({ color, label, testid }) {
  return (
    <span className="text-[0.7rem] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-sm tnum"
      style={{ color, background: `${color}1f` }} data-testid={testid}>
      {label}
    </span>
  );
}

export function StatusBadge({ status }) {
  const map = {
    confirmed: ["#4A7C59", "Confirmed"],
    pending: ["#9C9189", "Pending"],
    cancelled: ["#8B6914", "Withheld"],
    failed_reserve: ["#8B6914", "Withheld"],
    partial: ["#9C9189", "Partial"],
  };
  const [color, label] = map[status] || ["#9C9189", status];
  return <Badge color={color} label={label} testid={`status-badge-${status}`} />;
}

export function SentimentBadge({ sentiment }) {
  const map = {
    bullish: ["#4A7C59", "▲ Bullish"],
    bearish: ["#8B3A3A", "▼ Bearish"],
    neutral: ["#9C9189", "- Neutral"],
  };
  const [color, label] = map[sentiment] || map.neutral;
  return <Badge color={color} label={label} />;
}

export function TierBadge({ tier, role }) {
  if (role === "admin") return <Badge color="#C9A84C" label="Admin" />;
  const labels = { explorer: "Explorer", trader: "Trader", institutional: "Institutional" };
  return <Badge color="#C9A84C" label={labels[tier] || tier} />;
}

export function SourceBadge({ source, when }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-[0.62rem] uppercase tracking-[0.12em] text-bb-dim"
      data-testid="source-badge">
      <span className="w-1 h-1 rounded-full bg-bb-gold/70 inline-block" />
      {source}{when ? <span className="text-bb-dim/70">· {when}</span> : null}
    </span>
  );
}

export function InstitutionalBadge() {
  return (
    <span className="inline-flex items-center gap-1.5 text-[0.62rem] font-semibold uppercase tracking-[0.16em] px-2.5 py-1 rounded-sm bg-bb-gold text-bb-bg"
      data-testid="institutional-badge">
      Institutional Access
    </span>
  );
}

export function VerifiedBadge() {
  return (
    <span className="inline-flex items-center gap-1 text-[0.58rem] font-semibold uppercase tracking-[0.12em] px-1.5 py-0.5 rounded-sm text-bb-success" style={{ background: "#4A7C591f" }} data-testid="verified-badge">
      <span className="w-1 h-1 rounded-full bg-bb-success inline-block" /> Verified, Primary Source
    </span>
  );
}

const CREDIBILITY = {
  live: { color: "#4A7C59", label: "VDR Live" },
  modeled: { color: "#C8A24B", label: "VDR" },
  illustrative: { color: "#C8A24B", label: "VDR" },
};
const CRED_TITLE = "VDR data, produced by the registry's research desks and pricing engine.";

export function CredibilityBadge({ status = "illustrative", className = "" }) {
  const c = CREDIBILITY[status] || CREDIBILITY.illustrative;
  return (
    <a href="/methodology" title={CRED_TITLE} data-testid={`credibility-badge-${status}`}
      className={`inline-flex items-center gap-1.5 text-[0.58rem] font-semibold uppercase tracking-[0.12em] px-2 py-0.5 rounded-sm transition-opacity hover:opacity-80 ${className}`}
      style={{ color: c.color, background: `${c.color}1f` }}>
      <span className="w-1.5 h-1.5 rounded-full inline-block" style={{ background: c.color }} /> {c.label} Data
    </a>
  );
}
